import React from 'react';
import styles from './index.module.scss';

interface SectionPanelProps {
  title: string;
  titleSuffix?: React.ReactNode;
  extra?: React.ReactNode;
  className?: string;
  bodyClassName?: string;
  children: React.ReactNode;
}

const SectionPanel: React.FC<SectionPanelProps> = ({
  title,
  titleSuffix,
  extra,
  className,
  bodyClassName,
  children,
}) => {
  return (
    <section className={`${styles.sectionPanel} ${className ?? ''}`}>
      <div className={styles.sectionHeader}>
        <div className={styles.sectionTitleWrap}>
          <div className={styles.sectionTitle}>{title}</div>
          {titleSuffix && <div className={styles.sectionTitleSuffix}>{titleSuffix}</div>}
        </div>
        {extra && <div className={styles.sectionExtra}>{extra}</div>}
      </div>
      <div className={`${styles.sectionBody} ${bodyClassName ?? ''}`}>{children}</div>
    </section>
  );
};

export default SectionPanel;
